module.exports = require("./zh-Hans-MO");